package com.wintermar.inspection.feature.presentation.template.landing.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodyXLarge
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_template
import inspection.composeapp.generated.resources.templates
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun TemplateLandingPageHeader(
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
) {
    Row(
        modifier = Modifier
            .padding(dimension.spacing.space4)
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(
            dimension.spacing.space1
        )
    ) {
        Icon(
            painter = painterResource(Res.drawable.ic_template),
            tint = color.surface.accent.teal.medium.active,
            modifier = Modifier.size(dimension.size.icon.s),
            contentDescription = stringResource(Res.string.templates)
        )

        TextBodyXLarge(
            text = stringResource(Res.string.templates),
            bold = true,
            modifier = Modifier.weight(1f)
        )
    }
}
